import { Alert } from 'antd';
import React from "react";
import styles from './production-step.module.scss';

// import styles from '../../../components/data/quotation/quotation-item.module.scss';

const NewOrder = () => {
    return <div className={styles.container}>
        <h3>Tasks for you</h3>
        <Alert message="You have Recieved a new order" type='success' showIcon/>
        {/* <div className="actions">
            <Button type='primary' onClick={() => { }} ghost>Send</Button>
        </div> */}
    </div>
}

export default NewOrder;